module.exports = __webpack_public_path__ + "a79732facc069d5f34a7e829203c8ff2.png";